export type ComponentTag = (typeof componentTags)[keyof typeof componentTags];

export const componentTags = {
	MARKET_MOVERS: 'MARKET_MOVERS',
	ODDS_GRID: 'ODDS_GRID',
	OC_PLUS_TOOLS: 'OC_PLUS_TOOLS',
	PRICE_HISTORY: 'PRICE_HISTORY',
	TIPS: 'TIPS',
};
